import React from 'react';
import { Button } from '@mui/material';
import { TopSection } from '@/shared/layout';
import { OnboardingEventKeys, OnboardingEvents } from '@/profile';
import { EventBus } from '@/shared/utils';

interface OnboardingStartProps {
  eventBus: EventBus<OnboardingEvents>;
}

const OnboardingStart: React.FC<OnboardingStartProps> = ({ eventBus }) => {
  const startOnboarding = () => {
    eventBus.emit(OnboardingEventKeys.start.do, undefined);
  };

  return (
    <TopSection
      title="Ti diamo il benvenuto su Vibly!"
      subtitle="Dicci qualcosa in più su di te! Rispondi a queste poche domande per permetterci di offrirti l’esperienza migliore"
    >
      <Button
        size="large"
        variant="contained"
        color="primary"
        className="w-full"
        onClick={startOnboarding}
      >
        Iniziamo
      </Button>
    </TopSection>
  );
};

export default OnboardingStart;
